function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "speaker",
  transform: "translate(-30.136)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5999",
  "data-name": "Group 5999",
  transform: "translate(43.273 0.29)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5998",
  "data-name": "Group 5998",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6690",
  "data-name": "Path 6690",
  d: "M233.883,18.823l-14.1-14.1a2.12,2.12,0,1,0-3,3l14.1,14.1a2.118,2.118,0,1,0,3-3Z",
  transform: "translate(-216.163 -4.1)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6001",
  "data-name": "Group 6001",
  transform: "translate(37.718 5.855)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6000",
  "data-name": "Group 6000"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6691",
  "data-name": "Path 6691",
  d: "M142.623,82.9l-.106.532a22.773,22.773,0,0,1-5.023,10.173l7.673,7.673a22.7,22.7,0,0,1,10.124-5.072l.533-.106Z",
  transform: "translate(-137.494 -82.905)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6003",
  "data-name": "Group 6003",
  transform: "translate(30.136 18.149)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6002",
  "data-name": "Group 6002"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6692",
  "data-name": "Path 6692",
  d: "M36.311,256.989l-5.244,5.243a3.178,3.178,0,0,0,0,4.495l3,3a3.178,3.178,0,0,0,4.495,0l5.243-5.243Zm.749,8.24a1.059,1.059,0,0,1-1.5-1.5l1.5-1.5a1.059,1.059,0,0,1,1.5,1.5Z",
  transform: "translate(-30.136 -256.989)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6005",
  "data-name": "Group 6005",
  transform: "translate(41.554 24.441)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6004",
  "data-name": "Group 6004",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6693",
  "data-name": "Path 6693",
  d: "M198.483,353.081l1.441-1.441a3.175,3.175,0,0,0,0-4.494l-1.07-1.071a20.069,20.069,0,0,0-1.706,1.29l1.278,1.28a1.057,1.057,0,0,1,0,1.5l-1.465,1.465-2.153-2.086-3,3,4.806,4.657a2.119,2.119,0,0,0,2.995-3Z",
  transform: "translate(-191.813 -346.075)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6007",
  "data-name": "Group 6007",
  transform: "translate(51.444)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6006",
  "data-name": "Group 6006",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6694",
  "data-name": "Path 6694",
  d: "M332.923,0a1.059,1.059,0,0,0-1.059,1.059V3.178a1.059,1.059,0,1,0,2.119,0V1.059A1.059,1.059,0,0,0,332.923,0Z",
  transform: "translate(-331.864)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6009",
  "data-name": "Group 6009",
  transform: "translate(57.8 8.475)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6008",
  "data-name": "Group 6008"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6695",
  "data-name": "Path 6695",
  d: "M425.042,120h-2.119a1.059,1.059,0,0,0,0,2.119h2.119a1.059,1.059,0,0,0,0-2.119Z",
  transform: "translate(-421.864 -120)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6011",
  "data-name": "Group 6011",
  transform: "translate(55.682 2.119)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6010",
  "data-name": "Group 6010"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6696",
  "data-name": "Path 6696",
  d: "M395.791,30.31a1.059,1.059,0,0,0-1.5,0l-2.119,2.119a1.059,1.059,0,0,0,1.5,1.5l2.119-2.119A1.059,1.059,0,0,0,395.791,30.31Z",
  transform: "translate(-391.864 -30)",
  fill: "#fff"
}))));

var SvgSpeaker = function SvgSpeaker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.902,
    height: 36.158,
    viewBox: "0 0 31.902 36.158",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeaker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speaker.992c75a4.svg";
export { ForwardRef as ReactComponent };